import { Link } from "react-router-dom";
import ThumbnailAsset from "components/common/assets/ThumbnailAsset";

const ProjectTitle = (props) => {
    return (
        <Link
            to={"/projects/" + props.project.code}
            key={props.project.code}
            className="pb-2"
            data-aos="fade-up"
            data-aos-offset="-250"
            data-aos-delay={props.delay}
            data-aos-once="true"
        >
            {props.project.thumbnail ? (
                <ThumbnailAsset
                className
                    asset={props.project.thumbnail}
                    assetStyles="w-[calc(32*0.8rem)] h-[calc(20*0.66rem)] md:h-[calc(20*0.8rem)] object-cover rounded-md mx-auto md:mb-4 mb-2 hover:scale-105 transition-transform duration-300 ease-in-out "
                />

            ) : null}
            <div className="relative pt-1 md:pb-5">
                <p
                    className="text-center text-[1.5rem] tracking-tight"
                >
                    {typeof props.project.name === "string"
                        ? props.project.name
                        : props.project.name || "Loading Project Name"}
                </p>
            </div>
        </Link>
    )
}

export default ProjectTitle;